import React, { useEffect, useContext, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { store as mainStore } from '../../../../store';
import { store } from './Users';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '../../../../components/Accordion/Accordion';
import { isMobile } from 'react-device-detect';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import checkMobilePhone from '../../../../fns/checkMobilePhone';
import normalizeMobilePhone from '../../../../fns/normalizeMobile';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const UsersSearch = () => {
  const classes = useStyles();
  const firstRender = useRef(true);
  const timeout = useRef(null);
  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showMessage,
    showError,
  } = useContext(mainStore);
  const {
    state,
    dispatch,
    actions: { fetchingUsers },
  } = useContext(store);

  const {
    users,
    page,
    isLoaded,
    search: {
      firstName,
      lastName,
      nationalCode,
      company,
      companyNationalCode,
      mobilePhone,
      role,
      legal,
    },
  } = state;

  const handleChange = (e) => {
    let { name, value } = e.target;
    name === 'mobilePhone' && (value = checkMobilePhone(value) || value);
    dispatch({ type: 'CHANGE_FIELDS', payload: { name, value } });
  };
  const handleCB = (e) => {
    const { name, checked } = e.target;
    dispatch({ type: 'SELECT_ROLE', payload: { name, checked } });
  };
  const fetchUsers = async () => {
    try {
      dispatch({ type: 'LOADING' });
      const u = await fetchingUsers(page, itemsCountPerPage, state.search);
      dispatch({ type: 'LOADED' });
      dispatch({ type: 'USERS', payload: u });
    } catch (error) {
      showError(error);
    }
  }

  useEffect(() => {
    if (firstRender.current === true) {
      firstRender.current = false;
      return;
    }
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() =>{fetchUsers();},1000);
  }, [
    firstName,
    lastName,
    nationalCode,
    company,
    companyNationalCode,
    mobilePhone,
    role,
    legal,
  ]);

  return (
    <div className={classes.root}>
      <Accordion title="فیلترهای جستجو">
        <div className={classes.filters}>
          <TextField
            name="firstName"
            value={firstName}
            onChange={handleChange}
            variant="outlined"
            label="نام"
            size="small"
            fullWidth
          />
          <TextField
            name="lastName"
            value={lastName}
            onChange={handleChange}
            variant="outlined"
            label="نام خانوادگی"
            size="small"
            fullWidth
          />
          <TextField
            name="nationalCode"
            value={nationalCode}
            onChange={handleChange}
            variant="outlined"
            label="کدملی"
            size="small"
            fullWidth
          />
          <TextField
            name="company"
            value={company}
            onChange={handleChange}
            variant="outlined"
            label="نام‌شرکت"
            size="small"
            fullWidth
          />
          <TextField
            name="companyNationalCode"
            value={companyNationalCode}
            onChange={handleChange}
            variant="outlined"
            label="شناسه‌ملی‌شرکت"
            size="small"
            fullWidth
          />
          <TextField
            name="mobilePhone"
            value={mobilePhone ? normalizeMobilePhone(mobilePhone) : ''}
            onChange={handleChange}
            variant="outlined"
            label="موبایل"
            size="small"
            fullWidth
          />
          <FormControlLabel
            label="صاحبین‌بار"
            control={
              <Checkbox
                checked={role && role.includes('customer') ? true : false}
                onChange={handleCB}
                name="customer"
              />
            }
          />
          <FormControlLabel
            label="رانندگان"
            control={
              <Checkbox
                checked={role && role.includes('driver') ? true : false}
                onChange={handleCB}
                name="driver"
              />
            }
          />
          <FormControlLabel
            label="باربری‌ها"
            control={
              <Checkbox
                checked={role && role.includes('freight') ? true : false}
                onChange={handleCB}
                name="freight"
              />
            }
          />
          <FormControlLabel
            label="کارشناسان حمل"
            control={
              <Checkbox
                checked={role && role.includes('admin') ? true : false}
                onChange={handleCB}
                name="admin"
              />
            }
          />
          <FormControlLabel
            label="حقوقی"
            control={
              <Checkbox
                checked={legal ? true : false}
                onChange={handleCB}
                name="legal"
              />
            }
          />
        </div>
      </Accordion>
    </div>
  );
};

export default React.memo(UsersSearch);
